import { httpClient } from "../../httpClient";

type Payload = {
  fileurl: string;
};

type Data = any;
//
export async function uploadWorkday(payload: Payload): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(
      `/api/v1/admin/workday-upload`,
      payload
    );

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}


export const workday = {
    uploadWorkday,
};
